angular.module("app").controller('BannersAddPageController', [
    '$scope',
    function ($scope) {

    }
]);